module.exports = __webpack_public_path__ + "static/media/SOLDEMEXICO_25_feb.fb819778.jpg";